import { createApp } from 'vue';
import Pricing from '../components/pricing/Pricing.vue';

/**
 * pricing.js — Vue-остров блока "A typical Pro month" на /pricing.
 *
 * window.pricingData инжектится из pricing.volt (см. PageController + Service\PricingData):
 * {
 *   items: [ { slug, name, emoji, image_thumb, gradient, category_name, credits } ],
 *   credits_total, tokens_total, credits_used, credits_left, items_count, total_products
 * }
 *
 * Если данных нет или набор пуст — оставляем SSR-фолбэк из шаблона (не монтируем).
 */
document.addEventListener( 'DOMContentLoaded', () => {

    const el   = document.getElementById( 'vPricing' );
    const data = window.pricingData;

    if( ! el || ! data || ! Array.isArray( data.items ) || data.items.length === 0 )
        return;

    createApp( Pricing, {
        data,
        homeUrl: el.dataset.homeUrl || '',
    } ).mount( el );
} );
